import axiosInstance from './axiosInstance';

const fetchCards = async ({token, limitByDueDate = false}) => {
  try {
    const response = await axiosInstance.post(
      '/cards',
      {
        limit_by_due_date: limitByDueDate,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {fetchCards};